export default __webpack_public_path__ + "static/media/l_sit.409a80f3.svg";